import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import IndexesAndRatings from "~/views/indexes-and-ratings"

const getInitialProps: GetInitialPropsType = async ({ req }) => {
  const apiContext = await getApiContext(
    [{ url: "/index/list" }],
    req ? req.headers.host : location.host,
  )

  const crumbs = generateCrumbs(req?.url)
  return { apiContext, crumbs }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
IndexesAndRatings.getInitialProps = getInitialProps

export default IndexesAndRatings
